import React from 'react';

import { HeaderFirstAction as FirstAction } from '~ui'
import { Button } from '~co/user/profile';

export default function SidebarProfile() {
  return (
    <FirstAction className='flex-1'>
      <Button className='font-semibold'>
        {(user) => <span>{user.name}</span>}
      </Button>
    </FirstAction>
  );
}
